import { gql, type TypedDocumentNode } from "@apollo/client";
import { type GQL } from "@binale-tech/shared";

export const pendingWorkQuery: TypedDocumentNode<Pick<GQL.IQuery, "pendingWork">, GQL.IQueryPendingWorkArgs> = gql`
    query pendingWork($companyId: ID!, $year: Int!) {
        pendingWork(companyId: $companyId, year: $year) {
            year
            buckets {
                kind
                count
                sampleIds
                product
            }
        }
    }
`;

export const dmsDocumentFindTotalQuery: TypedDocumentNode<
    Pick<GQL.IQuery, "dmsDocumentFind">,
    GQL.IQueryDmsDocumentFindArgs
> = gql`
    query dmsDocumentFindTotal($input: DmsDocumentFindInput!) {
        dmsDocumentFind(input: $input) {
            total
        }
    }
`;

export const dmsDocumentFindDraftsQuery: TypedDocumentNode<
    Pick<GQL.IQuery, "dmsDocumentFind">,
    GQL.IQueryDmsDocumentFindArgs
> = gql`
    query dmsDocumentFindDrafts($input: DmsDocumentFindInput!) {
        dmsDocumentFind(input: $input) {
            total
            items {
                documentId
                type
                subType
            }
        }
    }
`;

export const documentsProcessAiMutation: TypedDocumentNode<
    Pick<GQL.IMutation, "documentsProcessAi">,
    GQL.IMutationDocumentsProcessAiArgs
> = gql`
    mutation documentsProcessAi($input: DocumentsProcessAiInput!) {
        documentsProcessAi(input: $input)
    }
`;

export const recordsAiReviewQuery: TypedDocumentNode<Pick<GQL.IQuery, "records">, GQL.IQueryRecordsArgs> = gql`
    query recordsAiReview($companyId: ID!, $product: ProductKey!, $year: Int!, $ids: [ID!], $limit: Int) {
        records(companyId: $companyId, product: $product, year: $year, ids: $ids, limit: $limit) {
            records {
                id
                state {
                    aiReview {
                        isValid
                        failedChecks
                    }
                }
            }
        }
    }
`;

export const elsterExportsAgentQuery: TypedDocumentNode<
    Pick<GQL.IQuery, "elsterExports">,
    GQL.IQueryElsterExportsArgs
> = gql`
    query elsterExportsAgent($companyId: String!, $year: Int!) {
        elsterExports(companyId: $companyId, year: $year) {
            id
            period
            createdAt
            ericResultCode
        }
    }
`;
